import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=58e1f916&scoped=true&"
import script from "./ActionButtons.vue?vue&type=script&lang=js&"
export * from "./ActionButtons.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=58e1f916&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e1f916",
  null
  
)

export default component.exports